import React, {useState, useEffect} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const UpdateProductionCostSubTotal = () => {
    const [crrTotal, setCrrTotal] = useState(0)
    const {productionTotalCost, subTotals} = React.useContext(RecipeUpdateContext)

    useEffect(() => {
        setCrrTotal(subTotals + productionTotalCost)
    }, [subTotals, productionTotalCost])

    return (
        <React.Fragment>
            <div>
                <h6 className={'font-bold'}>Ürün Maliyeti: <span>
                    {new Intl.NumberFormat().format(crrTotal)} USD
                </span></h6>
            </div>
        </React.Fragment>
    )
}
export default UpdateProductionCostSubTotal